module.exports = __webpack_public_path__ + "static/media/bulle_discovery_EN_1.20b88663.png";